import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import DonateButton from '@/components/DonateButton';
import CountdownBanner from '@/components/CountdownBanner';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <CountdownBanner />
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <DonateButton />
    </div>
  );
};

export default Layout;
